// src/redux/reducers/cityReducer.js
import {
    FETCH_GETCOMPANIES_FAILURE,
    FETCH_GETCOMPANIES_REQUEST,
    FETCH_GETCOMPANIES_SUCCESS, 
    SET_SELECTED_GETCOMPANIES ,
  } from '../types'; 
  
  const initialState = {
    loading: false,
    getcompaniesList: [],
    selectedcompaniesId: null, 
    error: null,
  };
  
  const getCompaniesReducer = (state = initialState, action) => {
    switch (action.type) {
      case FETCH_GETCOMPANIES_REQUEST:
        return { ...state, loading: true };
      case FETCH_GETCOMPANIES_SUCCESS:
        return { ...state, loading: false, getcompaniesList: action.payload };
      case FETCH_GETCOMPANIES_FAILURE:
        return { ...state, loading: false, error: action.payload };
      case SET_SELECTED_GETCOMPANIES:
        return { ...state, selectedcompaniesId: action.payload };
      default:
        return state;
    }
  };
  
  export default getCompaniesReducer;


  